import {
  STRING_VALUE_TYPE,
  ENUM_VALUE_TYPE,
  CELL_LAYOUT_TYPE,
} from 'grb-webui/components/FilterBar';
import LicenseFilterEditor from '../../components/LicenseFilterEditor';
import './KeyFilter.scss';

export default ({
  createTimeRangeEditor,
  useLicense = true,
  useUsage = true,
  useDisabled = true,
  useApplicationName = true,
  getKey,
  ...options
}) => {
  return {
    emptyChipLabel: 'All keys',
    dialogClassName: 'grb-apikey-dialog-filter',
    searchKey: 'search',
    propertyEditors: [
      useLicense ? LicenseFilterEditor(options) : null,
      {
        title: 'Access ID',
        name: 'key',
        type: STRING_VALUE_TYPE,
        layout: CELL_LAYOUT_TYPE,
        layoutConfig: { column: '1/-1' },
        className: 'grb-apikey-filter-access-id',
        getValueLabel(value) {
          return value === undefined ? 'All API Keys' : `API Key ${value}`;
        },
        createObjectFilter: getKey ? (key) => {
          if (!key) return undefined;
          return (o) => {
            const okey = getKey(o);
            return okey && okey.indexOf(key) >= 0;
          };
        } : undefined,
      },
      useDisabled && {
        title: 'Disabled',
        name: 'disabled',
        type: ENUM_VALUE_TYPE,
        layout: CELL_LAYOUT_TYPE,
        namedValues: [
          { value: undefined, label: 'All' },
          { value: 'true', label: 'Disabled' },
          { value: 'false', label: 'Not disabled' },
        ],
        createObjectFilter: (v) => {
          if (!v) {
            return () => true;
          }
          return (v === 'true') ? o => o.disabled : o => !o.disabled;
        },
      },
      useApplicationName && {
        title: 'Application',
        name: 'appName',
        type: STRING_VALUE_TYPE,
      },
      createTimeRangeEditor({
        title: useUsage ? 'Last usage time range' : 'Creation time range',
        getObjectDate: useUsage
        ? (k => new Date(k.usedAt || k.createdAt || 0))
        : (k => new Date(k.createdAt || 0)),
      }),
      options.cards && {
        name: 'mode',
        type: STRING_VALUE_TYPE,
        editable: false,
        createObjectFilter: () => () => true,
      },
    ].filter(e => e),
  };
};
